<template>
<section id="user-login-page">
    <div class="oneoftwo">

        <div class="inner-wrapper">
            <div class="form-container">
                <div class="logo">
                    <img src="@/assets/images/logo.svg" alt="Fluidra Polska" />
                </div>

                <!-- login form -->
                <template v-if="view.component === 'login'">
                    <div class="header">
                        <h1>Zaloguj się</h1>
                    </div>
                    <form action="#">
                        <label for="login">NIP</label>
                        <input :class="{'invalid': status.incorrect}" type="text" name="login" placeholder="Wprowadź NIP" v-model="form.login">

                        <label for="password">Hasło</label>
                        <input :class="{'invalid': status.incorrect}" type="password" name="password" placeholder="Hasło" v-model="form.pass">

                        <fieldset>
                        <label>
                            <input type="checkbox" name="checkbox" value="value" v-model="form.acceptance">
                            <span>Akceptuję <router-link :to="'/regulamin'">Regulamin Katalogu online Fluidra Polska sp. z o.o.</router-link></span></label>
                        </fieldset>

                        <p><a href="#" @click.prevent="view.component = 'resetPass'">Zresetuj hasło</a></p>
                        <button type="submit" @click.prevent="submitLoginForm()" :disabled="!submitActive" :class="{'preload': view.preload}"><span>Zaloguj się</span></button>
                        <p v-if="status.incorrect" class="incorrectStatus">Nieprawidłowy login lub hasło.</p>
                        <span class="or">lub</span>
                        <button class="join" @click.prevent="view.component = 'registerInfo'">Dołącz do programu Fluidra Polska</button>
                    </form>
                    <div class="pwa-info">
                        <div class="inner">
                            <img src="@/assets/images/app-icon.svg" alt="">
                            <p><b>Dodaj aplikację do pulpitu urządzenia</b> i miej ją zawsze pod ręką!</p>
                            <p><a href="#"  @click.prevent="view.component = 'pwaInfo'">Dowiedz się więcej</a></p>
                        </div>
                    </div>
                    </template>
                <!-- END login form -->

                 <!-- login form -->
                 <template v-if="view.component === 'resetPass'">
                    <div class="header">
                        <h1>Zresetuj hasło</h1>
                    </div>
                    <form action="#">
                        <label for="login">Adres email organizacji</label>
                        <input  type="text" name="resetEmail" placeholder="Adres email organizacji" v-model="form.resetEmail">
                        <button type="submit" @click.prevent="resetPassForm()"  :class="{'preload': view.preload}"><span>Ustaw nowe hasło</span></button>

                        <p class="incorrectStatus" v-if="status.resetSuccess" style="color: green;">Na wskazany adres email został przesłany link pozwalający ustawić nowe hasło.</p>
                        <p class="incorrectStatus" v-if="status.resetFailure">Nie istnieje konto zarejestrowana ne wskazany adres email. <br/>Jeżeli chcesz zostać naszym klientem prosimy o kontakt mailowy na adres <a href="mailto:biuro_pl@fluidra.com">biuro_pl@fluidra.com</a>.</p>
                        
                        
                    </form>
                    <div class="btn" style="margin-top: 32px"><button class="back" @click.prevent="view.component = 'login'"><span>Powrót</span></button></div>
                    </template>
                <!-- END login form -->

                <template v-if="view.component === 'registerInfo'">
                    <div class="header">
                        <h1>Dołącz do programu</h1>
                    
                    </div>
                    <div class="box">
                        <div class="inner">
                            <p>Uprzejmie informujemy, że nie prowadzimy sprzedaży detalicznej. Jeżeli chcesz zostać naszym klientem prosimy o kontakt mailowy na adres <a href="mailto:biuro_pl@fluidra.com">biuro_pl@fluidra.com</a>. <br/>Koniecznie podaj NIP firmy i telefon kontaktowy. <br/>Pozdrawiamy i czekamy na kontakt, <br/><b>Fluidra Team</b></p>
                        </div>
                    </div>
                        <div class="btn"><button class="back" @click.prevent="view.component = 'login'"><span>Powrót</span></button></div>
                </template>

              <template v-if="view.component === 'pwaInfo'">
                <div class="header">
                    <h1>Dodaj aplikację do pulpitu</h1>
                 
                </div>
                <div class="pwa-steps">
                        <div class="item">
                            <p>1.Naciśnij przycisk udostępniania.</p>
                            <img src="@/assets/images/pwa-step1.svg" alt="">
                        </div>
                        <div class="item">
                            <p>2. Naciśnij “Dodaj stronę do”</p>
                            <img src="@/assets/images/pwa-step2.svg" alt="">
                        </div>
                        <div class="item">
                            <p>3. Naciśnij “Ekran startowy”</p>
                            <img src="@/assets/images/pwa-step3.svg" alt="">
                        </div>
                    </div>
                    <div class="btn"><button class="back" @click.prevent="view.component = 'login'"><span>Powrót</span></button></div>
            </template>
            </div>
        </div>

    </div>
    <div class="oneoftwo">
        <img src="@/assets/images/login-decor.jpg" class="login-decor" loading="lazy" />
    </div>
</section>

</template>
<script>
import axios from 'axios';

export default{
name: 'Login',
data(){
    return{
        view: {
            preload: false,
            component: 'login'
        },
        status: {
            incorrect: false,
            resetSuccess: false,
            resetFailure: false
        },
        form: {
            login: '',
            pass: '',
            resetEmail: '',
            acceptance: false
        }
    }
},
methods: {

    submitLoginForm(){
        this.view.preload = true;
        axios.post("jwt-auth/v1/token", {
            username: this.form.login,
            password: this.form.pass
        }).then(({data}) => { 
            let userObj = {
                token: data.token,
                name: data.user_display_name
            }
            localStorage.setItem("user", JSON.stringify(userObj));
            this.$store.commit("setUserData", userObj);        
            this.$router.push('/home');

            this.view.preload = false;

        })
        .catch(err => {
            if(err.status === 403){
                this.view.preload = false;
                this.status.incorrect = true;
            } else {
                console.log('Err', err);
            }
        });
    },
    resetPassForm(){
        this.view.preload = true;
        axios.post("fluidra/v1/forget-password", {
            email: this.form.resetEmail,
        }).then(({data}) => { 
            this.view.preload = false;
            this.status.resetSuccess = true;
            this.status.resetFailure = false;
            this.form.resetEmail = '';

        })
        .catch(err => {
            console.log('Err', err);
            this.view.preload = false;
            this.status.resetSuccess = false;
            this.status.resetFailure = true;


        });
    }
},
computed: {
    submitActive(){
        if(this.form.login.length >= 3 && this.form.pass.length >= 1 && this.form.acceptance){
            return true;
        } else {
            return false;
        }
    }
}
}
</script>
<style lang="less" scoped>

</style>